/* ScentStation pair buy box v1.2 – landing page (page.pair). Builds the UI from the JSON in snippets/pair-buy-box.liquid.
   v1.2: subscription shipping shown as "+ shipping" unless sub_shipping is set (standard store rates for now).
   v1.1: adds a sticky "Add to cart" bar on mobile while the buy box is on screen and the summary button isn't. */
(function () {
  'use strict';

  var counter = 0;

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function moneyShort(c) { return c % 100 === 0 ? '$' + (c / 100) : money(c); }
  function scentNum(str) { var m = String(str || '').match(/(?:^|\D)(\d{3})(?!\d)/); return m ? m[1] : null; }
  function weeksOf(name) { var m = String(name || '').match(/(\d+)\s*-?\s*weeks?/i); return m ? parseInt(m[1], 10) : null; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function dateIn(weeks) {
    var d = new Date();
    d.setDate(d.getDate() + weeks * 7);
    return d.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' });
  }

  function init(root) {
    if (root.getAttribute('data-spb-ready')) return;
    root.setAttribute('data-spb-ready', '1');
    var cfgEl = root.querySelector('[data-spb-config]');
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[pair-buy-box] Bad config', e); return; }
    var uid = 'spb' + (++counter);

    /* ---- Data ---- */
    var refillById = {}, refillByNum = {};
    (cfg.refills || []).forEach(function (r) {
      refillById[r.id] = r;
      var n = scentNum(r.title);
      if (n && !refillByNum[n]) refillByNum[n] = r;
    });

    var scents = [], byNum = {}, unmatched = [];
    (cfg.diffusers || []).forEach(function (d) {
      var n = scentNum(d.title);
      if (!n || byNum[n] || !d.variant) return;
      var refill = (d.refillOverride && refillById[d.refillOverride]) || refillByNum[n] || null;
      if (!refill) unmatched.push(d.title);
      var s = { num: n, title: d.title, variant: d.variant, price: d.price, available: !!d.available, image: d.image, refill: refill };
      byNum[n] = s;
      scents.push(s);
    });
    scents.sort(function (x, y) { return x.num < y.num ? -1 : 1; });

    function ok(s) { return !!(s && s.available && s.refill && s.refill.available); }
    var okCount = scents.filter(ok).length;

    // Subscription cadences: weeks offered by every matched refill
    var weeksList = [];
    var firstRefill = scents.length && scents[0].refill;
    if (firstRefill && firstRefill.plans) {
      firstRefill.plans.forEach(function (p) {
        var w = weeksOf(p.name);
        if (w && weeksList.indexOf(w) === -1) weeksList.push(w);
      });
      weeksList.sort(function (x, y) { return x - y; });
    }
    function planFor(refill, weeks) {
      if (!refill || !refill.plans) return null;
      for (var i = 0; i < refill.plans.length; i++) if (weeksOf(refill.plans[i].name) === weeks) return refill.plans[i];
      return null;
    }
    var canSub = weeksList.length > 0;

    var pairs = String(cfg.pairs || '').split(',').map(function (chunk) {
      var m = chunk.trim().match(/^(\d{3})\s*\+\s*(\d{3})\s*:\s*(.+)$/);
      return m ? { a: m[1], b: m[2], label: m[3].trim() } : null;
    }).filter(function (p) { return p && ok(byNum[p.a]) && ok(byNum[p.b]); });

    /* ---- Initial state ---- */
    var q = [];
    try { q = (new URLSearchParams(window.location.search).get('scents') || '').split(/[\s,+]+/).filter(Boolean); } catch (e) {}
    function pick(want, avoid) {
      if (want && ok(byNum[want])) return want;
      for (var i = 0; i < scents.length; i++) if (ok(scents[i]) && scents[i].num !== avoid) return scents[i].num;
      return scents.length ? scents[0].num : null;
    }
    var state = { a: null, b: null, plan: canSub ? 'sub' : 'once', weeks: null, busy: false, error: '' };
    state.a = pick(q[0] || cfg.defaultA, null);
    state.b = pick(q[1] || cfg.defaultB, state.a);
    state.weeks = weeksList.indexOf(cfg.defaultWeeks) > -1 ? cfg.defaultWeeks : (weeksList[0] || null);

    /* ---- Design-mode notes ---- */
    var notes = [];
    if (cfg.designMode) {
      if (unmatched.length) notes.push('No matching refill found for: ' + unmatched.join('; ') + '. Check the 3-digit scent number in the refill variant names, or set custom.refill_variant.');
      if (scents.length && !canSub) notes.push('No subscription plans with "weeks" in their names were found on the refill product.');
      if (okCount < 2) notes.push('Fewer than two scents are in stock with a matching refill, so the pair can\'t be added.');
    }

    /* ---- Markup ---- */
    function options() {
      return scents.map(function (s) {
        return '<option value="' + s.num + '"' + (ok(s) ? '' : ' disabled') + '>' + esc(s.title) + (ok(s) ? '' : ' (sold out)') + '</option>';
      }).join('');
    }
    function pickCard(key, label) {
      return '<div class="spb-pick">' +
        '<div class="spb-thumb"><img data-img="' + key + '" alt="" width="64" height="64" loading="lazy"></div>' +
        '<div><label for="' + uid + '-' + key + '">' + esc(label) + '</label>' +
        '<select id="' + uid + '-' + key + '" data-select="' + key + '">' + options() + '</select>' +
        '<div class="spb-pick-price"><span class="ssp-muted">Diffuser</span><span data-price="' + key + '"></span></div></div>' +
        '</div>';
    }
    var html = '';
    if (notes.length) html += '<div class="spb-check"><strong>Pair buy box setup check</strong> (only visible in the theme editor)<ul><li>' + notes.map(esc).join('</li><li>') + '</li></ul></div>';
    html += '<div class="spb"><div class="spb-main">';
    if (pairs.length) {
      html += '<p class="spb-label" id="' + uid + '-pairs">Start with a popular pair</p><div class="spb-chips" role="group" aria-labelledby="' + uid + '-pairs">' +
        pairs.map(function (p, i) { return '<button type="button" class="spb-chip" data-pair="' + i + '" aria-pressed="false">' + esc(p.label) + '</button>'; }).join('') +
        '</div>';
    }
    html += '<div class="spb-picks">' + pickCard('a', cfg.labelA) + pickCard('b', cfg.labelB) + '</div>';

    html += '<fieldset style="border:0;margin:0;padding:0;min-width:0"><legend class="spb-label">Your matching refills</legend><div class="spb-plans">';
    if (canSub) {
      html += '<input class="spb-sr" type="radio" name="' + uid + '-plan" id="' + uid + '-sub" value="sub">' +
        '<label class="spb-plan" for="' + uid + '-sub"><span class="spb-plan-top"><span data-sub-title>Subscribe and save</span><span><span data-sub-price></span><s data-sub-was></s></span></span>' +
        '<span class="spb-plan-sub">2 refills per delivery' + (cfg.subShipping > 0 ? ', ' + moneyShort(cfg.subShipping) + ' flat shipping after today' : '') + '. Free diffuser every ' + ordinal(cfg.rewardEvery) + ' delivery. Skip, swap or cancel anytime.</span></label>';
    }
    html += '<input class="spb-sr" type="radio" name="' + uid + '-plan" id="' + uid + '-once" value="once">' +
      '<label class="spb-plan" for="' + uid + '-once"><span class="spb-plan-top"><span>One-time</span><span data-once-price></span></span>' +
      '<span class="spb-plan-sub">2 refills, just this order.</span></label>';
    html += '</div></fieldset>';

    if (canSub) {
      html += '<div data-sub-only><fieldset style="border:0;margin:0;padding:0;min-width:0"><legend class="spb-label">Deliver refills every</legend><div class="spb-weeks">' +
        weeksList.map(function (w) {
          return '<input class="spb-sr" type="radio" name="' + uid + '-weeks" id="' + uid + '-w' + w + '" value="' + w + '"><label class="spb-week" for="' + uid + '-w' + w + '">' + w + ' weeks</label>';
        }).join('') + '</div></fieldset>' +
        '<div class="spb-track"><div class="spb-steps" data-steps></div><p data-track-copy></p></div></div>';
    }
    html += '</div>'; // spb-main

    html += '<div class="spb-summary" aria-live="polite">' +
      '<p class="spb-title">' + esc(cfg.summaryTitle) + '</p>' +
      '<div class="spb-rows">' +
      '<div class="spb-row"><span data-row-a></span><span data-row-a-price></span></div>' +
      '<div class="spb-row"><span data-row-b></span><span><s data-row-b-was></s><span data-row-b-price></span></span></div>' +
      '<div class="spb-row"><span data-row-r></span><span data-row-r-price></span></div>' +
      '<div class="spb-row"><span>Shipping</span><span class="spb-free">Free</span></div>' +
      '</div>' +
      '<div class="spb-total"><span>Total today</span><strong data-total></strong></div>' +
      '<p class="spb-then" data-then></p>' +
      '<button type="button" class="spb-add" data-add></button>' +
      '<p class="spb-error" role="alert" data-error hidden></p>' +
      '<p class="spb-note" data-note></p>' +
      '</div></div>';

    var mount = document.createElement('div');
    mount.innerHTML = html;
    root.appendChild(mount);

    // Mobile sticky bar (shown by CSS on small screens only). Lives on <body> so theme
    // section animations (transforms) can't break position: fixed.
    var bar = document.createElement('div');
    bar.className = 'spb-bar';
    bar.hidden = true;
    bar.innerHTML = '<div class="spb-bar-txt"><strong data-bar-total></strong><span data-bar-sub></span></div>' +
      '<button type="button" class="spb-bar-btn" data-bar-add></button>';
    document.body.appendChild(bar);

    function $(sel) { return mount.querySelector(sel); }
    function $all(sel) { return Array.prototype.slice.call(mount.querySelectorAll(sel)); }

    function ordinal(n) {
      var s = ['th', 'st', 'nd', 'rd'], v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }

    /* ---- Render ---- */
    function update() {
      var A = byNum[state.a], B = byNum[state.b];
      var isSub = canSub && state.plan === 'sub';

      $('[data-select="a"]').value = state.a;
      $('[data-select="b"]').value = state.b;
      [['a', A], ['b', B]].forEach(function (pair) {
        var img = $('[data-img="' + pair[0] + '"]');
        if (pair[1] && pair[1].image) { img.src = pair[1].image; img.hidden = false; } else { img.hidden = true; }
      });

      var aPrice = A ? A.price : 0;
      var bFull = B ? B.price : 0;
      var bPrice = Math.min(cfg.secondPrice, bFull);
      $('[data-price="a"]').innerHTML = '<strong>' + money(aPrice) + '</strong>';
      $('[data-price="b"]').innerHTML = (bPrice < bFull ? '<s>' + money(bFull) + '</s>' : '') + '<strong>' + money(bPrice) + '</strong>';

      // refill prices
      var onceEach = [A, B].map(function (s) { return s && s.refill ? s.refill.price : 0; });
      var onceTotal = onceEach[0] + onceEach[1];
      var planA = isSub ? planFor(A && A.refill, state.weeks) : null;
      var planB = isSub ? planFor(B && B.refill, state.weeks) : null;
      var subTotalFor = function (weeks) {
        var pa = planFor(A && A.refill, weeks), pb = planFor(B && B.refill, weeks);
        return (pa ? pa.price : onceEach[0]) + (pb ? pb.price : onceEach[1]);
      };
      var subTotal = canSub ? subTotalFor(state.weeks) : onceTotal;
      var refillsToday = isSub ? subTotal : onceTotal;

      if (canSub) {
        $('#' + uid + '-sub').checked = isSub;
        var pct = onceTotal > 0 ? Math.round((1 - subTotal / onceTotal) * 100) : 0;
        $('[data-sub-title]').textContent = pct > 0 ? 'Subscribe and save ' + pct + '%' : 'Subscribe';
        $('[data-sub-price]').textContent = moneyShort(subTotal);
        $('[data-sub-was]').textContent = subTotal < onceTotal ? money(onceTotal) : '';
        $('[data-sub-only]').hidden = !isSub;
        weeksList.forEach(function (w) { $('#' + uid + '-w' + w).checked = w === state.weeks; });
        var steps = [];
        var every = Math.max(2, cfg.rewardEvery || 5);
        var shown = every <= 5 ? range(1, every) : [1, 2, 3, null, every];
        shown.forEach(function (n) {
          if (n === null) { steps.push('<div class="spb-step"><b>…</b><span></span></div>'); return; }
          var label = n === 1 ? 'Today' : (n === every ? 'Free diffuser' : dateIn(state.weeks * (n - 1)));
          steps.push('<div class="spb-step' + (n === every ? ' is-free' : '') + '"><b>' + n + '</b><span>' + esc(label) + '</span></div>');
        });
        var stepsEl = $('[data-steps]');
        stepsEl.style.gridTemplateColumns = 'repeat(' + shown.length + ', minmax(0, 1fr))';
        stepsEl.innerHTML = steps.join('');
        $('[data-track-copy]').textContent = 'Your ' + ordinal(every) + ' delivery, around ' + dateIn(state.weeks * (every - 1)) + ', includes a free diffuser in any scent you choose.';
      }
      $('#' + uid + '-once').checked = !isSub;
      $('[data-once-price]').textContent = money(onceTotal);

      // pair chips
      $all('[data-pair]').forEach(function (btn) {
        var p = pairs[+btn.getAttribute('data-pair')];
        btn.setAttribute('aria-pressed', p.a === state.a && p.b === state.b ? 'true' : 'false');
      });

      // summary
      $('[data-row-a]').textContent = A ? A.title : '';
      $('[data-row-a-price]').textContent = money(aPrice);
      $('[data-row-b]').textContent = B ? B.title : '';
      $('[data-row-b-was]').textContent = bPrice < bFull ? money(bFull) : '';
      $('[data-row-b-price]').textContent = money(bPrice);
      $('[data-row-r]').textContent = '2 matching refills' + (isSub ? ' (first delivery)' : '');
      $('[data-row-r-price]').textContent = money(refillsToday);
      var total = aPrice + bPrice + refillsToday;
      $('[data-total]').textContent = money(total);
      var then = $('[data-then]');
      then.hidden = !isSub;
      then.textContent = 'Then ' + moneyShort(subTotal) + ' + ' + (cfg.subShipping > 0 ? moneyShort(cfg.subShipping) + ' ' : '') + 'shipping every ' + state.weeks + ' weeks for your refills.';
      $('[data-note]').textContent = isSub ? 'Ships free. Skip, swap or cancel refills anytime.' : 'Ships free.';

      // availability
      var problem = '';
      if (!ok(A) || !ok(B)) problem = 'One of these scents is sold out. Pick another.';
      else if (isSub && (!planA || !planB)) problem = 'That delivery frequency isn\'t available for one of these refills.';
      var add = $('[data-add]');
      add.disabled = !!problem || state.busy;
      add.textContent = state.busy ? 'Adding…' : (problem || ('Add to cart: ' + money(total)));
      var err = $('[data-error]');
      err.hidden = !state.error;
      err.textContent = state.error;

      // mobile bar
      bar.querySelector('[data-bar-total]').textContent = money(total) + ' today';
      bar.querySelector('[data-bar-sub]').textContent = isSub ? 'Ships free · then ' + moneyShort(subTotal) + ' + ' + (cfg.subShipping > 0 ? moneyShort(cfg.subShipping) : 'shipping') + ' every ' + state.weeks + ' wks' : 'Ships free';
      var barBtn = bar.querySelector('[data-bar-add]');
      barBtn.disabled = !!problem || state.busy;
      barBtn.textContent = state.busy ? 'Adding…' : (problem ? 'Sold out' : 'Add to cart');
    }

    function range(a, b) { var r = []; for (var i = a; i <= b; i++) r.push(i); return r; }

    /* ---- Events ---- */
    $('[data-select="a"]').addEventListener('change', function (e) { state.a = e.target.value; state.error = ''; update(); });
    $('[data-select="b"]').addEventListener('change', function (e) { state.b = e.target.value; state.error = ''; update(); });
    $all('[data-pair]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var p = pairs[+btn.getAttribute('data-pair')];
        state.a = p.a; state.b = p.b; state.error = ''; update();
      });
    });
    $all('input[name="' + uid + '-plan"]').forEach(function (el) {
      el.addEventListener('change', function () { state.plan = el.value; state.error = ''; update(); });
    });
    $all('input[name="' + uid + '-weeks"]').forEach(function (el) {
      el.addEventListener('change', function () { state.weeks = parseInt(el.value, 10); state.error = ''; update(); });
    });

    $('[data-add]').addEventListener('click', function () {
      var A = byNum[state.a], B = byNum[state.b];
      var isSub = canSub && state.plan === 'sub';
      if (!ok(A) || !ok(B)) return;
      var lines = [
        { id: A.variant }, { id: B.variant },
        { id: A.refill.id, plan: isSub ? planFor(A.refill, state.weeks) : null },
        { id: B.refill.id, plan: isSub ? planFor(B.refill, state.weeks) : null }
      ];
      if (isSub && (!lines[2].plan || !lines[3].plan)) return;
      // merge identical lines (same scent picked twice)
      var items = [], index = {};
      lines.forEach(function (l) {
        var key = l.id + '|' + (l.plan ? l.plan.id : '');
        if (index[key] !== undefined) { items[index[key]].quantity += 1; return; }
        var item = { id: l.id, quantity: 1 };
        if (l.plan) item.selling_plan = l.plan.id;
        index[key] = items.length;
        items.push(item);
      });

      var base = cfg.root || '/';
      if (base.slice(-1) !== '/') base += '/';
      state.busy = true; state.error = ''; update();
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (data) { if (!r.ok) throw data; return data; });
      }).then(function () {
        var dest = cfg.afterAdd === 'checkout' ? base + 'checkout' : base + 'cart';
        if (cfg.testCode) dest = base + 'discount/' + encodeURIComponent(cfg.testCode) + '?redirect=' + encodeURIComponent(dest.replace(/^https?:\/\/[^/]+/, ''));
        window.location.href = dest;
      }).catch(function (e) {
        state.busy = false;
        state.error = (e && (e.description || e.message)) || 'Something went wrong adding your pair. Please try again.';
        update();
        var errEl = $('[data-error]');
        if (errEl && errEl.scrollIntoView) errEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    });

    /* ---- Mobile sticky bar: visible while the buy box is on screen and the summary button isn't ---- */
    bar.querySelector('[data-bar-add]').addEventListener('click', function () { $('[data-add]').click(); });
    if ('IntersectionObserver' in window) {
      var boxVisible = false, addVisible = false;
      var sync = function () { bar.hidden = !(boxVisible && !addVisible); };
      new IntersectionObserver(function (es) { boxVisible = es[0].isIntersecting; sync(); }, { rootMargin: '0px 0px -120px 0px' }).observe(mount.querySelector('.spb'));
      new IntersectionObserver(function (es) { addVisible = es[0].isIntersecting; sync(); }).observe($('[data-add]'));
    }

    update();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pair-buy-box]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Theme editor: re-run when a section is re-rendered
  document.addEventListener('shopify:section:load', boot);
})();
